import graphql__a1ce27452f6e677537ad from "./__generated__/ResumeOralInterviewMutation.graphql.js";import { commitMutation, graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__a1ce27452f6e677537ad;

const resumeOralInterview = (
  variables,
  onCompleted,
  onError = error => console.error(error)
) =>
  commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError
  });

export { resumeOralInterview };
